/**
 * in this file is stored all react query keys
 * to provide to our custom useQuery
 * BEHOLD: we expect one enum for each topic
 */

export enum ProclientQueryKeys {
  "ALL_CONTRACTS" = "PROCLIENT_ALL_CONTRACTS",
  "PAYMENT_SETTINGS" = "PROCLIENT_PAYMENT_SETTINGS",
  "PRICING_STRATEGY" = "PROCLIENT_PRICING_STRATEGY",
  "PROCLIENT" = "PROCLIENT",
  "PROCLIENTS" = "PROCLIENTS",
  "PROCLIENT_MEMBER" = "PROCLIENT_MEMBER",
  "PROCLIENT_SHORT" = "PROCLIENT_SHORT",
  "ALL_PRESCRIBERS_FOR_PROCLIENT" = "ALL_PRESCRIBERS_FOR_PROCLIENT",
  "CONTACT" = "PROCLIENT_CONTACT",
  "URSSAF_ACCOUNT" = "PROCLIENT_URSSAF_ACCOUNT",
  "LAST_LOGIN" = "PROCLIENT_LAST_LOGIN",
  "MISSING_ASSERTIONS" = "PROCLIENT_MISSING_ASSERTIONS",
  "SCORING" = "PROCLIENT_SCORING",
  "SUGGESTIONS" = "PROCLIENT_SUGGESTIONS",
  "QUALITY_CONTACTS" = "PROCLIENT_QUALITY_CONTACTS",
  "CALL_EVALUATION" = "PROCLIENT_CALL_EVALUATION",
  "CALL_EVALUATION_SYNC" = "PROCLIENT_CALL_EVALUATION_SYNC",
  "VEB_EVALUATION" = "PROCLIENT_VEB_EVALUATION",
  "HISTORICAL_PRICING_STRATEGY" = "PROCLIENT_HISTORICAL_PRICING_STRATEGY",
  "CONTRACT" = "PROCLIENT_CONTRACT",
  "QUALITY_MONITORING_QA" = "PROCLIENT_QUALITY_MONITORING_QA",
  "QUALITY_MONITORING_QA_SURVEY" = "PROCLIENT_QUALITY_MONITORING_QA_SURVEY",
  "QUALITY_MONITORING_DAILY_REPORTS" = "PROCLIENT_QUALITY_MONITORING_DAILY_REPORTS",
  "PLANNING" = "PROCLIENT_PLANNING",
  "DOCUMENT" = "PROCLIENT_DOCUMENTS",
  "PICO_BADGE" = "PROCLIENT_PICO_BADGES",
  "MISSION_INSTRUCTIONS" = "PROCLIENT_MISSION_INSTRUCTIONS",
  "INTERVENTIONS" = "PROCLIENT_INTERVENTIONS",
  "FINANCIAL_HELP" = "PROCLIENT_FINANCIAL_HELP",
  "CUSTOMER_SERVICE_TICKET" = "PROCLIENT_CUSTOMER_SERVICE_TICKET",
  "ISSUES" = "PROCLIENT_ISSUES",
  "MEMBER_SUBSCRIBED_PACKAGES" = "PROCLIENT_MEMBER_SUBSCRIBED_PACKAGES",
  "CAREGIVER_RELATION" = "CAREGIVER_RELATION",
  "THIRD_PARTY_COVERAGE" = "THIRD_PARTY_COVERAGE",
  "THIRD_PARTY_COVERAGE_CONDITIONS" = "THIRD_PARTY_COVERAGE_CONDITIONS",
  "PROCLIENT_LOGS" = "PROCLIENT_LOGS",
  "LINKED_CAREGIVERS" = "PROCLIENT_LINKED_CAREGIVERS",
}

export enum PicoQueryKeys {
  "INTERVENTION" = "PICO_INTERVENTION",
  "INTERVENTIONS_TO_STAFF" = "PICO_INTERVENTIONS_TO_STAFF",
  "INTERVENTION_TO_STAFF_PROPOSITIONS" = "PICO_INTERVENTION_TO_STAFF_PROPOSITIONS",
  "INTERVENTION_TO_STAFF" = "PICO_INTERVENTION_TO_STAFF",
  "INTERVENTIONS_TO_STAFF_REPLACED_CAREGIVER" = "PICO_INTERVENTIONS_TO_STAFF_REPLACED_CAREGIVER",
  "BADGE" = "PICO_BADGE",
  "QUESTION" = "PICO_QUESTION",
  "ABSENCE" = "PICO_ABSENCE",
}

export enum CompassQueryKeys {
  "PROCLIENT_DAILY_REPORT" = "COMPASS_PROCLIENT_DAILY_REPORT",
  "INTERVENTION_TO_FILL" = "COMPASS_INTERVENTION_TO_FILL",
  "COUNTER_CAREGIVER_SCORING_MONITORING" = "COMPASS_COUNTER_CAREGIVER_SCORING_MONITORING",
  "COUNTER_PROCLIENT_SCORING_MONITORING" = "COMPASS_COUNTER_PROCLIENT_SCORING_MONITORING",
  "COUNTER_PICO_INTERVENTION" = "COMPASS_COUNTER_PICO_INTERVENTION",
  "COUNTER_SURVEY_FOLLOWUPS" = "COMPASS_COUNTER_SURVEY_FOLLOWUPS",
  "COUNTER_QAS_PULSE_CHECK" = "COMPASS_COUNTER_QAS_PULSE_CHECK",
  "COUNTER_TODO_EVENTS" = "COMPASS_COUNTER_TODO_EVENTS",
  "QA" = "COMPASS_QA",
  "QA_END_INTERVENTION" = "COMPASS_QA_END_INTERVENTION",
  "QA_PULSE_CHECK" = "COMPASS_QA_PULSE_CHECK",
  "QA_INTERVENTION" = "COMPASS_QA_INTERVENTION",
  "STAFFING" = "COMPASS_STAFFING",
  "EVENT" = "COMPASS_EVENT",
  "CAREGIVER_LOGS" = "COMPASS_CAREGIVER_LOGS",
  "CAREGIVER_QUALITY_MONITORING" = "COMPASS_CAREGIVER_QUALITY_MONITORING",
  "CAREGIVER_MISSING_ASSERTIONS" = "COMPASS_CAREGIVER_MISSING_ASSERTIONS",
  "PROCLIENT_QUALITY_MONITORING" = "COMPASS_PROCLIENT_QUALITY_MONITORING",
  "PROCLIENT_INTERVENTION_PAUSED" = "COMPASS_PROCLIENT_INTERVENTION_PAUSED",
  "ENVELOPE_MONITORING" = "COMPASS_ENVELOPE_MONITORING",
  "PROCLIENT_ISSUE" = "COMPASS_PROCLIENT_ISSUE",
  "CUSTOMER_SERVICE_INCOMING_REQUESTS" = "COMPASS_CUSTOMER_SERVICE_INCOMING_REQUESTS",
  "PROCLIENT_PLAN" = "COMPASS_PROCLIENT_PLAN",
  "PICO_INTERVENTION" = "COMPASS_PICO_INTERVENTION",
  "STAFFING_COUNTER" = "COMPASS_STAFFING_COUNTER",
  "INTERVENTION_FOLLOWUPS_COUNTER" = "COMPASS_INTERVENTION_FOLLOWUPS_COUNTER",
  "PICO_COUNTER" = "COMPASS_PICO_COUNTER",
  "CAREGIVER_RECRUITMENT_COUNTER" = "COMPASS_CAREGIVER_RECRUITMENT_COUNTER",
  "PROCLIENT_FOLLOWUPS_COUNTER" = "COMPASS_PROCLIENT_FOLLOWUPS_COUNTER",
  "CAREGIVER_ADMIN_SECTION_COUNTER" = "COMPASS_CAREGIVER_ADMIN_SECTION_COUNTER",
  "CAREGIVER_FOLLOWUPS_COUNTER" = "COMPASS_CAREGIVER_FOLLOWUPS_COUNTER",
  "CUSTOMER_SERVICE_TICKET_COUNTER" = "COMPASS_CUSTOMER_SERVICE_TICKET_COUNTER",
}

export enum CaregiverQueryKeys {
  "AUDIT_LOGS" = "CAREGIVER_AUDIT_LOGS",
  "BIRTHDAYS" = "CAREGIVER_BIRTHDAYS",
  "ABSENCES" = "CAREGIVER_ABSENCES",
  "SCORING" = "CAREGIVER_SCORING",
  "CAREGIVER" = "CAREGIVER",
  "CAREGIVER_SHORT" = "CAREGIVER_SHORT",
  "RECRUITING_POOL" = "CAREGIVERS_RECRUITING_POOL",
  "DOCUMENTS" = "CAREGIVER_DOCUMENTS",
  "ASSERTIONS" = "CAREGIVER_ASSERTIONS",
  "MISSING_ASSERTIONS" = "CAREGIVER_MISSING_ASSERTIONS",
  "CONTACTS" = "CAREGIVER_CONTACTS",
  "PUBLIC_PROFILE" = "CAREGIVER_PUBLIC_PROFILE",
  "PAYFLIX_IMPORT_REPORT" = "CAREGIVER_PAYFLIX_IMPORT_REPORT",
  "BROADCAST" = "CAREGIVER_BROADCAST",
  "QUESTION" = "CAREGIVER_QUESTION",
  "CANDIDATE" = "CAREGIVER_CANDIDATE",
  "TEXT_MESSAGE" = "CAREGIVER_TEXT_MESSAGE",
  "QUALITY_MONITORING_END_INTERVENTION" = "CAREGIVER_QUALITY_MONITORING_END_INTERVENTION",
  "QUALITY_MONITORING_PULSE_CHECK" = "CAREGIVER_QUALITY_MONITORING_PULSE_CHECK",
  "CONTRACT" = "CAREGIVER_CONTRACT",
  "SEARCH" = "CAREGIVER_SEARCH",
  "PLANNING" = "CAREGIVER_PLANNING",
  "ENVELOPES" = "CAREGIVER_ENVELOPES",
  "TRAINING" = "CAREGIVER_TRAINING",
  "SUBSCRIBED_TRAINING" = "CAREGIVER_SUBSCRIBED_TRAINING",
  "SIGNABLES_READY" = "CAREGIVER_SIGNABLES_READY",
  "SIGNABLE" = "CAREGIVER_SIGNABLE",
  "AGENCY" = "CAREGIVER_AGENCY",
  "DAYS_OFF" = "CAREGIVER_DAYS_OFF",
  "CUSTOMER_SERVICE_TICKET" = "CAREGIVER_CUSTOMER_SERVICE_TICKET",
  "CANDIDATES" = "CAREGIVER_CANDIDATES",
  "CANDIDATE_APPLICATIONS" = "CAREGIVER_CANDIDATE_APPLICATIONS",
  "PROCLIENT_MEMBER_RELATION" = "CAREGIVER_PROCLIENT_MEMBER_RELATION",
  "XIMI_CONTRACT" = "CAREGIVER_XIMI_CONTRACT",
  "XIMI_AMENDMENTS" = "CAREGIVER_XIMI_AMENDMENTS",
  "XIMI_WORKSCHEDULES" = "CAREGIVER_XIMI_WORKSCHEDULES",
  "CONTRACTOR_CONTRACTS" = "CAREGIVER_CONTRACTOR_CONTRACTS",
  "INTERVENTION_REPORTS" = "CAREGIVER_INTERVENTION_REPORTS",
}

export enum SignablesQueryKeys {
  "SIGNABLES_METADATA" = "SIGNABLES_METADATA",
  "SIGNABLE_METADATA" = "SIGNABLE_METADATA",
}

export enum PrescriberQueryKeys {
  "STRUCTURE" = "PRESCRIBER_STRUCTURE",
  "PRESCRIBER" = "PRESCRIBER",
  "PRESCRIBERS" = "PRESCRIBERS",
  "FOLLOWUP" = "PRESCRIBER_FOLLOWUP",
  "ALL_PROCLIENTS_FOR_PRESCRIBER" = "ALL_PROCLIENTS_FOR_PRESCRIBER",
  "STRUCTURE_PRESCRIBER" = "PRESCRIBER_STRUCTURE_PRESCRIBER",
  "STRUCTURE_PROCLIENT" = "PRESCRIBER_STRUCTURE_PROCLIENT",
  "PRESCRIBER_LOGS" = "PRESCRIBER_LOGS",
}

export enum CgpcQueryKeys {
  "ANNIVERSARIES" = "CGPC_ANNIVERSARIES",
  "CONTRACT" = "CGPC_CONTRACT",
  "CONTRACTS" = "CGPCS_CONTRACT",
  "SIGNABLES_READY" = "CGPC_SIGNABLES_READY",
  "RELATION" = "CGPC_RELATION",
  "BLACKLIST_CAREGIVER_PROCLIENT" = "CGPC_BLACKLIST_CAREGIVER_PROCLIENT",
}

export enum DocumentQueryKeys {
  "DOCUMENTS" = "DOCUMENTS",
}

export enum CollaboratorQueryKeys {
  "COLLABORATOR" = "COLLABORATOR",
  "COLLABORATOR_BY_DSIT_UUID" = "COLLABORATOR_BY_DSIT_UUID",
  "COLLABORATORS" = "COLLABORATORS",
  "COLLABORATOR_AGENCY" = "COLLABORATOR_AGENCY",
  "COLLABORATOR_TASK" = "COLLABORATOR_TASK",
  "COLLABORATOR_TASKS" = "COLLABORATOR_TASKS",
  "COLLABORATOR_CHAT_SETTINGS" = "COLLABORATOR_CHAT_SETTINGS",
  "COLLABORATOR_NOTIFICATIONS" = "COLLABORATOR_NOTIFICATIONS",
  "COLLABORATOR_NOTIFICATION_READ" = "COLLABORATOR_NOTIFICATION_READ",
  "CONTRACTOR_COLLABORATOR_AGENCY" = "CONTRACTOR_COLLABORATOR_AGENCY",
  "COLLABORATOR_LEAVES" = "COLLABORATOR_LEAVES",
  "COLLABORATOR_CALENDAR_EVENTS" = "COLLABORATOR_CALENDAR_EVENTS",
  "ME" = "ME",
}

export enum MonetQueryKeys {
  "BILL" = "MONET_BILL",
  "SELECTABLE_BILL" = "MONET_SELECTABLE_BILL",
  "PAYMENT" = "MONET_PAYMENT",
  "BALANCE" = "MONET_BALANCE",
  "PROCLIENT_MEMBER_PAYMENT_INTENT" = "PROCLIENT_MEMBER_PAYMENT_INTENT",
  "CAREGIVER_PAYMENT_INTENT" = "CAREGIVER_PAYMENT_INTENT",
  "PAYMENT_INTENT_EVENTS" = "MONET_PAYMENT_INTENT_EVENTS",
  "REGULARIZATION" = "REGULARIZATION",
  "THIRD_PARTY_PAYER" = "MONET_THIRD_PARTY_PAYER",
  "THIRD_PARTY_PAYER_V2" = "MONET_THIRD_PARTY_PAYER_V2",
  "THIRD_PARTY_PAYERS" = "MONET_THIRD_PARTY_PAYERS",
  "THIRD_PARTY_PAYER_COVERAGES" = "MONET_THIRD_PARTY_PAYER_COVERAGES",
  "TAX_CREDIT_REQUEST" = "MONET_TAX_CREDIT_REQUEST",
  "PAY_RUN" = "MONET_PAY_RUN",
  "ESPPADOM_DELIVERY" = "MONET_ESPPADOM_DELIVERY",
  "CONTRACTOR_REGULARIZATIONS" = "MONET_CONTRACTOR_REGULARIZATIONS"
}

export enum AgencyQueryKeys {
  "DEFAULT_PRICING_STRATEGIES" = "AGENCY_DEFAULT_PRICING_STRATEGY_TEMPLATE",
}

export enum PostalCodeQueryKeys {
  "SEARCH" = "POSTAL_CODE_SEARCH",
}

export enum SearchEntitiesQueryKeys {
  "SEARCH_ENTITIES" = "SEARCH_ENTITIES",
  "SEARCH_PRESCRIBERS" = "SEARCH_PRESCRIBERS",
}

export enum NavitiaQueryKeys {
  "TRANSPORTATION" = "NAVITIA_TRANSPORTATION",
}

export enum SurveyQueryKeys {
  "QA" = "QA_SURVEY",
}

export enum UrssafRegionQueryKeys {
  "URSSAF_REGIONS" = "URSSAF_REGIONS",
}

export enum LegalStructuresInformationQueryKeys {
  "LEGAL_STRUCTURES_INFORMATION" = "LEGAL_STRUCTURES_INFORMATION",
  "LEGAL_STRUCTURE_INFORMATION_FOR_PROCLIENT" = "LEGAL_STRUCTURE_INFORMATION_FOR_PROCLIENT",
}

export enum AuthQueryKeys {
  "SHORT_LIVED_TOKEN" = "SHORT_LIVED_TOKEN",
}

export enum EntityOriginBindingQueryKeys {
  "ENTITY_ORIGIN_BINDING" = "ENTITY_ORIGIN_BINDING",
}

export enum EventQueryKeys {
  "EVENT" = "EVENT",
  "FUTURE_UNDEBRIEFED_EVENTS" = "FUTURE_UNDEBRIEFED_EVENTS",
}

export enum MailQueryKeys {
  "GET_STATUS" = "GET_STATUS",
}

export enum MetabaseQueryKeys {
  "METABASE_COLLECTIONS" = "METABASE_COLLECTIONS",
  "METABASE_IFRAME_URL" = "METABASE_IFRAME_URL",
}

export enum CustomerServiceKeys {
  "CUSTOMER_SERVICE_TICKETS" = "CUSTOMER_SERVICE_TICKETS",
}

export enum EnvelopeKeys {
  "EXPECTED_SIGNATORIES" = "EXPECTED_SIGNATORIES",
}

export enum TableRefreshQueryKeys {
  "TABLE_REFRESH" = "TABLE_REFRESH",
}

export const listQueryKey = "LIST";
export const idbQueryKey = "INDEX_DB";

// this may seems long but it allows us to keep list query keys in sync
export type HassibotQueryKeys =
  | CaregiverQueryKeys
  | CollaboratorQueryKeys
  | DocumentQueryKeys
  | MonetQueryKeys
  | PicoQueryKeys
  | ProclientQueryKeys
  | PrescriberQueryKeys
  | SearchEntitiesQueryKeys
  | SurveyQueryKeys
  | UrssafRegionQueryKeys
  | CompassQueryKeys
  | AgencyQueryKeys
  | PostalCodeQueryKeys
  | SignablesQueryKeys
  | CgpcQueryKeys
  | AuthQueryKeys
  | EventQueryKeys
  | MailQueryKeys
  | MetabaseQueryKeys
  | typeof listQueryKey
  | typeof idbQueryKey;

export enum OcrQueryKeys {
  "BANK_ACCOUNT_JOB" = "BANK_ACCOUNT_JOB",
}
